import type { TextInputSize } from './types'

/**
 * Высота поля по size (спека 01 §24-25: 54/60). Токена под 54 нет
 * ($control-height-m — 50, $control-height-xl — 60), поэтому M — задокументированное
 * отклонение спеки, L берёт $control-height-xl.
 */
export const TEXT_INPUT_HEIGHT: Record<TextInputSize, string> = {
  M: '54px',
  L: 'var(--control-height-xl)',
}
